export default __webpack_public_path__ + "static/media/s3.0f4c9476.svg";